module.exports = __webpack_public_path__ + "static/media/img_coupon5.93958e02.png";